import { render } from "./PopupDisplay.vue?vue&type=template&id=76283484&scoped=true"
import script from "./PopupDisplay.vue?vue&type=script&lang=js"
export * from "./PopupDisplay.vue?vue&type=script&lang=js"

import "./PopupDisplay.vue?vue&type=style&index=0&id=76283484&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76283484"]])

export default __exports__